import { useContext } from 'react';
import styled from 'styled-components';
import { HelperTextStyle } from './HelperText.styles.js';
import { FormContext } from '../Form/FormContext.js';
import { FormRowContext } from '../FormRow/FormRowContext.js';

const defaultProps = {
    error: false,
    sizing: 'medium',
};
const HelperText = styled.p.attrs(({ sizing }) => {
    var _a, _b;
    const formContext = useContext(FormContext);
    const formRowContext = useContext(FormRowContext);
    return {
        sizing: (_b = (_a = sizing !== null && sizing !== void 0 ? sizing : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.sizing) !== null && _a !== void 0 ? _a : formContext === null || formContext === void 0 ? void 0 : formContext.sizing) !== null && _b !== void 0 ? _b : defaultProps.sizing,
    };
}) `
    ${HelperTextStyle}
`;

export { HelperText, defaultProps };
//# sourceMappingURL=HelperText.js.map
